import { ActiveOfficeStore } from "@Front/Stores/ActiveOfficeStore.core";

let _activeOfficeStoreInstance: ActiveOfficeStore | null = null;

export function getActiveOfficeStore(): ActiveOfficeStore {
	if (!_activeOfficeStoreInstance) {
		_activeOfficeStoreInstance = new ActiveOfficeStore();
	}
	return _activeOfficeStoreInstance;
}

let _activeOfficeStoreBackwardCompat: ActiveOfficeStore | undefined;
let _activeOfficeStoreProxy: ActiveOfficeStore | undefined;

function getActiveOfficeStoreInstance(): ActiveOfficeStore {
	if (!_activeOfficeStoreBackwardCompat) {
		_activeOfficeStoreBackwardCompat = getActiveOfficeStore();
	}
	return _activeOfficeStoreBackwardCompat;
}

function getActiveOfficeStoreProxy(): ActiveOfficeStore {
	if (!_activeOfficeStoreProxy) {
		_activeOfficeStoreProxy = new Proxy({} as ActiveOfficeStore, {
			get(_target, prop): unknown {
				return (getActiveOfficeStoreInstance() as unknown as Record<string, unknown>)[prop as string];
			},
			set(_target, prop, value): boolean {
				(getActiveOfficeStoreInstance() as unknown as Record<string, unknown>)[prop as string] = value;
				return true;
			},
		});
	}
	return _activeOfficeStoreProxy;
}

export const activeOfficeStore = new Proxy({} as ActiveOfficeStore, {
	get(_target, prop): unknown {
		return (getActiveOfficeStoreProxy() as unknown as Record<string, unknown>)[prop as string];
	},
	set(_target, prop, value): boolean {
		(getActiveOfficeStoreProxy() as unknown as Record<string, unknown>)[prop as string] = value;
		return true;
	},
});
